import isProd from '../constants/isProd'
import dev_parts from '../../data/parts.json'

const getJsonLMParts = () => {
    return isProd ? window.search_results_parts : dev_parts
}

export default getJsonLMParts
